import React from 'react';

function Partners(){
  const partners = [
    { name: 'University of South Bohemia', src: '/partner_logos/jhc_logo.jpg' },
    { name: 'Czech Technical University (CTU)', src: '/partner_logos/ctu_logo.png' },
    { name: 'SentionX', src: '/partner_logos/sentionx_logo.jpeg' }
  ];

  return (
    <section id="partners">
      <h2 style={{ textAlign: 'center', marginBottom: '28px' }}>Selected partners & collaborators</h2>
      <div className="partner-logos">
        {partners.map(p => (
          <div key={p.name} className="partner-logo partner-logo-tile glass-card">
            <img src={p.src} alt={p.name} className="partner-logo-image" />
          </div>
        ))}
      </div>
    </section>
  );
}

export default Partners;
